'use strict';

var Joi = require('joi');
var dateTime = require('@ksyos/date-time');
var lodash = require('lodash');

// The `validate` method is part of Joi so it cannot be refactored
/* eslint-disable max-params-no-constructor/max-params-no-constructor */
const dateTemplate = 'YYYY-MM-DD';
const timeTemplate = 'HH:mm:ss';
const dateTimeTemplate = `${dateTemplate} ${timeTemplate}`;
function isDateTimeLike(value) {
    return typeof value === 'string' || typeof value === 'number' || value instanceof Date || value instanceof dateTime.DateTime;
}
const koiExtension = (_joi) => {
    return {
        messages: {
            'koi.afterNow': '{{#label}} needs to be after now',
            'koi.afterToday': '{{#label}} needs to be after today',
            'koi.beforeNow': '{{#label}} needs to be before now',
            'koi.beforeToday': '{{#label}} needs to be before today',
            'koi.date': '{{#label}} needs to be a valid date string',
            'koi.dateAfter': '{{#label}} needs to be after the given date',
            'koi.dateBefore': '{{#label}} needs to be before the given date',
            'koi.dateSameOrAfter': '{{#label}} needs to be on or after the given date',
            'koi.dateSameOrBefore': '{{#label}} needs to be on or before the given date',
            'koi.datetime': '{{#label}} needs to be a valid datetime string',
            'koi.endDate': '{{#label}} needs to be larger than or equal to start date',
            'koi.enum': '{{#label}} needs to be an enum value',
            'koi.missingStartDate': '{{#label}} a startDate field is missing',
            'koi.time': '{{#label}} needs to be a valid time string',
            'koi.timeWithoutSeconds': '{{#label}} needs to be a valid time without seconds string',
            'koi.today': '{{#label}} needs to be today',
            'koi.todayOrAfter': '{{#label}} needs to be today or after',
            'koi.todayOrBefore': '{{#label}} needs to be today or before',
        },
        rules: {
            afterNow: {
                method() {
                    return this.$_addRule('afterNow');
                },
                validate(
                // value: ValidateValue<TValue, DateTimeLike>,
                value, helpers, _args, _options) {
                    if (isDateTimeLike(value) && dateTime.DateTime.from(value).isAfter(dateTime.DateTime.now())) {
                        return value;
                    }
                    else {
                        return helpers.error('koi.afterNow');
                    }
                },
            },
            afterToday: {
                method() {
                    return this.$_addRule('afterToday');
                },
                validate(value, helpers, _args, _options) {
                    if (isDateTimeLike(value) && dateTime.DateTime.from(value).isSameOrAfter(dateTime.DateTime.today().add(1, 'day'))) {
                        return value;
                    }
                    else {
                        return helpers.error('koi.afterToday');
                    }
                },
            },
            beforeNow: {
                method() {
                    return this.$_addRule('beforeNow');
                },
                validate(value, helpers, _args, _options) {
                    if (isDateTimeLike(value) && dateTime.DateTime.from(value).isBefore(dateTime.DateTime.now())) {
                        return value;
                    }
                    else {
                        return helpers.error('koi.beforeNow');
                    }
                },
            },
            beforeToday: {
                method() {
                    return this.$_addRule('beforeToday');
                },
                validate(value, helpers, _args, _options) {
                    if (isDateTimeLike(value) && dateTime.DateTime.from(value).isBefore(dateTime.DateTime.today())) {
                        return value;
                    }
                    else {
                        return helpers.error('koi.beforeToday');
                    }
                },
            },
            date: {
                method() {
                    return this.$_addRule('date');
                },
                validate(value, helpers, _args, _options) {
                    if (typeof value === 'string' && dateTime.DateTime.parseExact(value, dateTemplate).isValid()) {
                        return value;
                    }
                    else {
                        return helpers.error('koi.date');
                    }
                },
            },
            dateAfter: {
                method(date) {
                    return this.$_addRule({
                        args: { date },
                        name: 'dateAfter',
                    });
                },
                validate(value, helpers, args, _options) {
                    const valueDate = dateTime.DateTime.from(value);
                    const otherDate = dateTime.DateTime.from(args.date);
                    if (!valueDate.isValid() || !otherDate.isValid()) {
                        return helpers.error('koi.date');
                    }
                    else if (valueDate.isAfter(otherDate)) {
                        return value;
                    }
                    else {
                        return helpers.error('koi.dateAfter');
                    }
                },
            },
            dateBefore: {
                method(date) {
                    return this.$_addRule({
                        args: { date },
                        name: 'dateBefore',
                    });
                },
                validate(value, helpers, args, _options) {
                    const valueDate = dateTime.DateTime.from(value);
                    const otherDate = dateTime.DateTime.from(args.date);
                    if (!valueDate.isValid() || !otherDate.isValid()) {
                        return helpers.error('koi.date');
                    }
                    else if (valueDate.isBefore(otherDate)) {
                        return value;
                    }
                    else {
                        return helpers.error('koi.dateBefore');
                    }
                },
            },
            dateSameOrAfter: {
                method(date) {
                    return this.$_addRule({
                        args: { date },
                        name: 'dateSameOrAfter',
                    });
                },
                validate(value, helpers, args, _options) {
                    const valueDate = dateTime.DateTime.from(value);
                    const otherDate = dateTime.DateTime.from(args.date);
                    if (!valueDate.isValid() || !otherDate.isValid()) {
                        return helpers.error('koi.date');
                    }
                    else if (valueDate.isSameOrAfter(otherDate)) {
                        return value;
                    }
                    else {
                        return helpers.error('koi.dateSameOrAfter');
                    }
                },
            },
            dateSameOrBefore: {
                method(date) {
                    return this.$_addRule({
                        args: { date },
                        name: 'dateSameOrBefore',
                    });
                },
                validate(value, helpers, args, _options) {
                    const valueDate = dateTime.DateTime.from(value);
                    const otherDate = dateTime.DateTime.from(args.date);
                    if (!valueDate.isValid() || !otherDate.isValid()) {
                        return helpers.error('koi.date');
                    }
                    else if (valueDate.isSameOrBefore(otherDate)) {
                        return value;
                    }
                    else {
                        return helpers.error('koi.dateSameOrBefore');
                    }
                },
            },
            datetime: {
                method() {
                    return this.$_addRule('datetime');
                },
                validate(value, helpers, _args, _options) {
                    if (typeof value === 'string' && dateTime.DateTime.parseExact(value, dateTimeTemplate).isValid()) {
                        return value;
                    }
                    else {
                        return helpers.error('koi.datetime');
                    }
                },
            },
            endDate: {
                method() {
                    return this.$_addRule('endDate');
                },
                validate(value, helpers, _args, _options) {
                    const ancestors = helpers.state.ancestors;
                    const startDate = ancestors.length > 0 ? ancestors[0].startDate : undefined;
                    if (startDate === undefined) {
                        return helpers.error('koi.missingStartDate');
                    }
                    else if (startDate === null || value === null) {
                        return value;
                    }
                    else if (dateTime.DateTime.from(value).isSameOrAfter(startDate)) {
                        return value;
                    }
                    else {
                        return helpers.error('koi.endDate');
                    }
                },
            },
            enum: {
                args: [
                    {
                        assert: Joi.object().pattern(/.*/, Joi.string().required()),
                        message: 'needs to be an enum',
                        name: 'jsEnum',
                        ref: true,
                    },
                ],
                method(jsEnum) {
                    return this.$_addRule({
                        args: { jsEnum },
                        name: 'enum',
                    });
                },
                validate(value, helpers, args, _options) {
                    if (lodash.values(args.jsEnum).indexOf(value) >= 0) {
                        return value;
                    }
                    else {
                        return helpers.error('koi.enum');
                    }
                },
            },
            time: {
                method() {
                    return this.$_addRule('time');
                },
                validate(value, helpers, _args, _options) {
                    if (typeof value === 'string' && dateTime.DateTime.parseExact(value, timeTemplate).isValid()) {
                        return value;
                    }
                    else {
                        return helpers.error('koi.time');
                    }
                },
            },
            timeWithoutSeconds: {
                method() {
                    return this.$_addRule('timeWithoutSeconds');
                },
                validate(value, helpers, _args, _options) {
                    if (typeof value === 'string' && dateTime.DateTime.parseExact(value, 'HH:mm').isValid()) {
                        return value;
                    }
                    else {
                        return helpers.error('koi.timeWithoutSeconds');
                    }
                },
            },
            today: {
                method() {
                    return this.$_addRule('today');
                },
                validate(value, helpers, _args, _options) {
                    if (isDateTimeLike(value) && dateTime.DateTime.from(value).startOf('day').isSame(dateTime.DateTime.today())) {
                        return value;
                    }
                    else {
                        return helpers.error('koi.today');
                    }
                },
            },
            todayOrAfter: {
                method() {
                    return this.$_addRule('todayOrAfter');
                },
                validate(value, helpers, _args, _options) {
                    if (isDateTimeLike(value) && dateTime.DateTime.from(value).startOf('day').isSameOrAfter(dateTime.DateTime.today())) {
                        return value;
                    }
                    else {
                        return helpers.error('koi.todayOrAfter');
                    }
                },
            },
            todayOrBefore: {
                method() {
                    return this.$_addRule('todayOrBefore');
                },
                validate(value, helpers, _args, _options) {
                    if (isDateTimeLike(value) && dateTime.DateTime.from(value).isBefore(dateTime.DateTime.today().add(1, 'day'))) {
                        return value;
                    }
                    else {
                        return helpers.error('koi.todayOrBefore');
                    }
                },
            },
        },
        type: 'koi',
    };
};
const stringExtension = (joi) => {
    return {
        base: joi.string(),
        messages: {
            'string.elfproef': '{{#label}} needs to pass the elfproef',
            'string.ledgerNumber': '{{#label}} needs to be a string consisting of 4 digits',
            'string.newPasswordRepeat': '{{#label}} needs to match the new password',
            'string.numeric': '{{#label}} needs to be a string consisting of only numbers',
            'string.registrationCode': '{{#label}} needs to be a string of 12 upper case letters',
            'string.simpleEmail': '{{#label}} needs to be a valid email address',
            'string.totpToken': '{{#label}} needs to be a string of six digits',
            'string.zipCodeNL': '{{#label}} needs to be a string with 4 numbers and 2 capital letters',
        },
        rules: {
            elfproef: {
                method() {
                    return this.$_addRule('elfproef');
                },
                validate(value, helpers, _args, _options) {
                    if (typeof value === 'string' && elfproef(value)) {
                        return value;
                    }
                    else {
                        return helpers.error('string.elfproef');
                    }
                },
            },
            ledgerNumber: {
                method() {
                    return this.$_addRule('ledgerNumber');
                },
                validate(value, helpers, _args, _options) {
                    if (typeof value === 'string' && /^[0-9]{4}$/.test(value)) {
                        return value;
                    }
                    else {
                        return helpers.error('string.ledgerNumber');
                    }
                },
            },
            newPasswordRepeat: {
                method() {
                    return this.$_addRule('newPasswordRepeat');
                },
                validate(value, helpers, _args, _options) {
                    const ancestors = helpers.state.ancestors;
                    const newPassword = ancestors.length > 0 ? ancestors[0].newPassword : undefined;
                    if (value === newPassword) {
                        return value;
                    }
                    else {
                        return helpers.error('string.newPasswordRepeat');
                    }
                },
            },
            numeric: {
                method() {
                    return this.$_addRule('numeric');
                },
                validate(value, helpers, _args, _options) {
                    if (typeof value === 'string' && /^[0-9]*$/.test(value)) {
                        return value;
                    }
                    else {
                        return helpers.error('string.numeric');
                    }
                },
            },
            registrationCode: {
                method() {
                    return this.$_addRule('registrationCode');
                },
                validate(value, helpers, _args, _options) {
                    if (typeof value === 'string' && /^[A-Z]{12}$/.test(value)) {
                        return value;
                    }
                    else {
                        return helpers.error('string.registrationCode');
                    }
                },
            },
            simpleEmail: {
                method() {
                    return this.$_addRule('simpleEmail');
                },
                validate(value, helpers, _args, _options) {
                    if (typeof value === 'string' && /^.+@.+$/.test(value)) {
                        return value;
                    }
                    else {
                        return helpers.error('string.simpleEmail');
                    }
                },
            },
            totpToken: {
                method() {
                    return this.$_addRule('totpToken');
                },
                validate(value, helpers, _args, _options) {
                    if (typeof value === 'string' && /^\d{6}$/.test(value)) {
                        return value;
                    }
                    else {
                        return helpers.error('string.totpToken');
                    }
                },
            },
            zipCodeNL: {
                method(isSpaceRequired = false) {
                    return this.$_addRule({ args: { isSpaceRequired }, name: 'zipCodeNL' });
                },
                validate(value, helpers, args, _options) {
                    const regex = args.isSpaceRequired
                        ? /^[1-9][0-9]{3} (?!SA|SD|SS)[A-Z]{2}$/
                        : /^[1-9][0-9]{3} ?(?!SA|SD|SS)[A-Z]{2}$/;
                    if (typeof value === 'string' && regex.test(value)) {
                        return value;
                    }
                    else {
                        return helpers.error('string.zipCodeNL');
                    }
                },
            },
        },
        type: 'string',
    };
};
const limitArg = {
    assert: Joi.number(),
    message: 'needs to be a number',
    name: 'limit',
    ref: true,
};
const decimalSeparatorArg = {
    assert: Joi.valid('.', ','),
    message: 'needs to be a decimal separator',
    name: 'decimalSeparator',
    ref: true,
};
const digitsArg = Object.assign(Object.assign({}, limitArg), { name: 'digits' });
const numberAsStringExtension = (_joi) => {
    return {
        flags: {
            decimalSeparator: {
                setter: '_decimalSeparator',
            },
            maxDecimals: {
                default: 0,
                setter: '_minDecimals',
            },
            minDecimals: {
                default: 0,
                setter: '_minDecimals',
            },
        },
        messages: {
            'numberAsString.decimalComma': '{{#label}} must have a decimal comma',
            'numberAsString.decimalPoint': '{{#label}} must have a decimal point',
            'numberAsString.greater': '{{#label}} needs to be higher',
            'numberAsString.leadingZero': '{{#label}} must not have a leading zero',
            'numberAsString.less': '{{#label}} needs to be lower',
            'numberAsString.max': '{{#label}} needs to be lower',
            'numberAsString.maxDecimals': '{{#label}} needs to have fewer decimals',
            'numberAsString.min': '{{#label}} needs to be higher',
            'numberAsString.minDecimals': '{{#label}} needs to have more decimals',
            'numberAsString.negativeZero': '{{#label}} must not be negative zero',
            'numberAsString.noDecimals': '{{#label}} must not have decimals',
            'numberAsString.notANumber': '{{#label}} needs to be a number',
            'numberAsString.notAString': '{{#label}} needs to be a number as a string',
        },
        rules: {
            decimal: {
                args: [decimalSeparatorArg, digitsArg],
                method(decimalSeparator, digits) {
                    return this
                        .decimalSeparator(decimalSeparator)
                        .minDecimals(digits)
                        .maxDecimals(digits);
                },
            },
            decimalSeparator: {
                args: [decimalSeparatorArg],
                method(value) {
                    return this.$_setFlag('_decimalSeparator', value);
                },
            },
            greater: {
                args: [limitArg],
                method(limit) {
                    return this.$_addRule({ args: { limit }, name: 'greater' });
                },
                validate(value, helpers, args, _options) {
                    if (numberFromString(value, helpers) > args.limit) {
                        return value;
                    }
                    else {
                        return helpers.error('numberAsString.greater');
                    }
                },
            },
            less: {
                args: [limitArg],
                method(limit) {
                    return this.$_addRule({ args: { limit }, name: 'less' });
                },
                validate(value, helpers, args, _options) {
                    if (numberFromString(value, helpers) < args.limit) {
                        return value;
                    }
                    else {
                        return helpers.error('numberAsString.less');
                    }
                },
            },
            max: {
                args: [limitArg],
                method(limit) {
                    return this.$_addRule({ args: { limit }, name: 'max' });
                },
                validate(value, helpers, args, _options) {
                    if (numberFromString(value, helpers) <= args.limit) {
                        return value;
                    }
                    else {
                        return helpers.error('numberAsString.max');
                    }
                },
            },
            maxDecimals: {
                args: [digitsArg],
                method(digits) {
                    return this.$_setFlag('_maxDecimals', digits);
                },
            },
            min: {
                args: [limitArg],
                method(limit) {
                    return this.$_addRule({ args: { limit }, name: 'min' });
                },
                validate(value, helpers, args, _options) {
                    if (numberFromString(value, helpers) >= args.limit) {
                        return value;
                    }
                    else {
                        return helpers.error('numberAsString.min');
                    }
                },
            },
            minDecimals: {
                args: [digitsArg],
                method(digits) {
                    return this.$_setFlag('_minDecimals', digits);
                },
            },
        },
        type: 'numberAsString',
        validate(value, helpers) {
            if (typeof value !== 'string') {
                return { errors: helpers.error('numberAsString.notAString'), value };
            }
            if (helpers.prefs.convert) {
                value = value.trim();
            }
            let i = 0;
            let negative = false;
            if (value[i] === '-') {
                negative = true;
                i++;
            }
            if (i === value.length) {
                return { errors: helpers.error('numberAsString.notANumber'), value };
            }
            const wrongLeadingZero = value[i] === '0' && i + 1 < value.length && !/[.,]/.test(value[i + 1]);
            let decimalSeparator;
            while (i < value.length) {
                if (/[.,]/.test(value[i])) {
                    decimalSeparator = value[i];
                    i++;
                    break;
                }
                else if (/[0-9]/.test(value[i])) {
                    i++;
                }
                else {
                    return { errors: helpers.error('numberAsString.notANumber'), value };
                }
            }
            const indexBeforeDecimals = i;
            while (i < value.length) {
                if (/[0-9]/.test(value[i])) {
                    i++;
                }
                else {
                    return { errors: helpers.error('numberAsString.notANumber'), value };
                }
            }
            const decimals = i - indexBeforeDecimals;
            if (decimalSeparator) {
                if (decimals === 0) {
                    return { errors: helpers.error('numberAsString.notANumber'), value };
                }
                const flag = helpers.schema.$_getFlag('_decimalSeparator');
                if (flag === undefined) {
                    return { errors: helpers.error('numberAsString.noDecimals'), value };
                }
                if (flag === ',' && decimalSeparator !== flag) {
                    return {
                        errors: helpers.error('numberAsString.decimalComma'),
                        value,
                    };
                }
                if (flag === '.' && decimalSeparator !== flag) {
                    return {
                        errors: helpers.error('numberAsString.decimalPoint'),
                        value,
                    };
                }
            }
            if (wrongLeadingZero) {
                return {
                    errors: helpers.error('numberAsString.leadingZero'),
                    value,
                };
            }
            if (negative && numberFromString(value, helpers) === 0) {
                return {
                    errors: helpers.error('numberAsString.negativeZero'),
                    value,
                };
            }
            if (decimals > helpers.schema.$_getFlag('_maxDecimals')) {
                return {
                    errors: helpers.error('numberAsString.maxDecimals'),
                    value,
                };
            }
            if (decimals < helpers.schema.$_getFlag('_minDecimals')) {
                return {
                    errors: helpers.error('numberAsString.minDecimals'),
                    value,
                };
            }
            return { value: value };
        },
    };
};
const objectExtension = (joi) => {
    return {
        base: joi.object(),
        messages: {
            'object.anyFilledIn': '{{#label}} needs to contain at least one filled in key',
        },
        rules: {
            anyFilledIn: {
                method(...keysToCheck) {
                    return this.$_addRule({ args: { keysToCheck }, name: 'anyFilledIn' });
                },
                validate(peers, helpers, args, _options) {
                    const keysToCheck = args.keysToCheck.length > 0 ? args.keysToCheck : Object.keys(peers);
                    const someFilledIn = keysToCheck.some((key) => peers[key] !== null && peers[key] !== '' && peers[key] !== false);
                    if (!someFilledIn) {
                        return helpers.error('object.anyFilledIn');
                    }
                    return peers;
                },
            },
        },
        type: 'object',
    };
};
const Koi = Joi.extend(koiExtension, stringExtension, numberAsStringExtension, objectExtension);
function elfproef(bsn) {
    if (bsn.length < 8 || bsn.length > 9) {
        return false;
    }
    let sum = 0;
    for (let i = 0; i < bsn.length; i++) {
        sum += parseInt(bsn[i], 10) * (i === bsn.length - 1 ? -1 : bsn.length - i);
    }
    return sum % 11 === 0;
}
function numberFromString(value, helpers) {
    if (helpers.schema.$_getFlag('_decimalSeparator') === ',') {
        return Number(value.replace(',', '.'));
    }
    else {
        return Number(value);
    }
}

exports.Joi = Joi;
exports.Koi = Koi;
